<div id="topic-navigator">
  <div id="progress-title" class="no-gutters">
    <div class="col-10 col-lg-12 no-gutters">
      <h3 class="mb-4">{{ messages.getText('WILL.interview.progress-title') }}</h3>
    </div>
    <div class="col-2 d-lg-none no-gutters navbar-toggle-div">
      @if (navigatorCollapsed) {
        <button class="navbar-toggler pull-right borderless"
                type="button"
                data-toggle="collapse"
                data-target="#collapsible-stage-navbar"
                aria-label="Interview progress"
                (click)="navigatorCollapsed = !navigatorCollapsed"
        >
          <img class="arrow-text-down" src="https://bequeathedassets.s3.eu-west-2.amazonaws.com/myintent/icons/dropdown_roundel-white.svg" alt="Dropdown arrow">
          <p class="mx-2 my-auto">{{ messages.getText('btn.expand') }}</p>
        </button>
      }
    </div>
  </div>
  <div id="progressBarTotal"
       class="progress-bar total"
       role="progressbar"
       [attr.aria-label]="messages.getText('WILL.interview.progress-label', [progressAsString])"
       [attr.aria-valuenow]="progress"
       [attr.aria-valuemin]="0"
       [attr.aria-valuemax]="100"
       tabindex="0">
    <div id="progressBarCompleted" class="progress-bar completed" [style.width.%]="progress"></div>
  </div>
  <div class="border-0 alert alert-query mt-2 mb-0 px-3">{{ messages.getText('WILL.interview.edit-topic') }}</div>
  <nav class="navbar navbar-expand-lg" >
    <div id="collapsible-stage-navbar" class="collapse navbar-collapse" [ngbCollapse]="navigatorCollapsed">
      <ol>
        @if(!!navigator) {
          @for (topic of navigator!.topics! | keyvalue:sortByOrder; track topic.key;) {
            @let isCurrentTopic = topic.key == this.currentTopic?.id;
            <ng-container>
              @if (!!topic.key) { <!-- Check this -->
                <li class="form-group position-relative no-gutters topic">
                  <div class="no-gutters row">
                    <div class="col-1 stage-index" [attr.aria-label]="'Step ' + ($index + 1)">
                      <span class="circle"
                            [class.stage-index-current]="isCurrentTopic"
                            [class.stage-index-completed]="topic.value.completed">
                        @if (isLocked(topic.value)) {
                          <i class="fa fa-lock lock-icon" [attr.aria-hidden]="true"></i>
                        } @else if (isReturnToLatest(topic.value)) {
                          <i class="fa fa-arrow-left you-are-here-icon" [attr.aria-hidden]="true"></i>
                        } @else if (isNavigable(topic.value)) {
                          <i class="fa fa-check edit-icon" [attr.aria-hidden]="true"></i>
                        } @else if (isCurrentTopic) {
                          <i class="fa fa-pencil editing-icon" [attr.aria-hidden]="true"></i>
                        }
                      </span>
                    </div>
                    <div class="my-auto col-9">
                      @if (isNavigable(topic.value)) {
                        @let returnToLatest = isReturnToLatest(topic.value);
                        <div class="no-gutters navigable">
                          <button type="button"
                                  class="topic-jump borderless"
                                  [attr.aria-label]="returnToLatest
                                    ? messages.getText('WILL.interview.return-to-latest', [messages.getText(type + '.topic.' + topic.value.id)])
                                    : messages.getText('WILL.interview.return-to-topic', [messages.getText(type + '.topic.' + topic.value.id)])"
                                  (click)="onJumpToTopic(topic.value)">
                            <h5 class="topic-title"
                                [attr.data-text]="getTooltipText(topic.value)"
                                [title]="(returnToLatest ? 'Return to latest: ' : 'Edit: ') + getTooltipText(topic.value)">
<!--                              <i class="fa fa-arrow-circle-o-right edit-icon" [attr.aria-hidden]="true"></i>-->
                              {{ messages.getText(type + ".topic." + topic.value.id) }}
                            </h5>
                          </button>
                        </div>
                      } @else if (isLocked(topic.value)) {
                        <div class="no-gutters topic-locked"
                             [attr.aria-label]="messages.getText('WILL.interview.locked-topic', [messages.getText(type + '.topic.' + topic.value.id)])">
                          <h5 class="topic-title"
                              [attr.data-text]="getTooltipText(topic.value)"
                              [title]="'Locked: ' + getTooltipText(topic.value)">
<!--                            <i class="fa fa-lock lock-icon" [attr.aria-hidden]="true"></i>-->
                            {{ messages.getText(type + ".topic." + topic.value.id) }}
                          </h5>
                        </div>
                      } @else if (editing) {
                        <div class="no-gutters">
                          <h5 class="topic-title"
                              [class.stage-title-current]="isCurrentTopic"
                              [attr.data-text]="getTooltipText(topic.value)"
                              [attr.aria-current]="isCurrentTopic ? 'step' : null">
<!--                            <i class="fa fa-pencil edit-icon" [attr.aria-hidden]="true"></i>-->
                            {{ messages.getText(type + ".topic." + topic.value.id!) }}
                          </h5>
                        </div>
                      } @else {
                          <h5 class="topic-title"
                              [class.stage-title-current]="isCurrentTopic"
                              [attr.data-text]="getTooltipText(topic.value)"
                              [attr.aria-current]="isCurrentTopic ? 'step' : null">
                            @if (isCurrentTopic) {
<!--                              <i class="fa fa-pencil editing-icon" [attr.aria-hidden]="true"></i>-->
                            }
                            {{ messages.getText(type + ".topic." + topic.value.id) }}
                          </h5>
                      }

                    </div>
                  </div>
                </li>
              }
            </ng-container>
          }
        }
      </ol>
      <div class="mt-3 navbar-toggle-div navbar-toggle-div-bottom">
        <button class="mb-3 navbar-toggler borderless"
                type="button"
                data-toggle="collapse"
                data-target="#collapsible-stage-navbar"
                aria-label="Topic navigation close"
                (click)="navigatorCollapsed = true"
        >
          <img class="arrow-text-up" src="https://bequeathedassets.s3.eu-west-2.amazonaws.com/myintent/icons/dropdown_roundel-white.svg" alt="Dropdown arrow">
          <p class="mx-2 my-auto">Close</p>
        </button>
      </div>
    </div>
  </nav>
</div>
